import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_5 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_6 = {
  class: "btn btn-success mr-1",
  style: {"padding":"0.7em 2em"}
}
const _hoisted_7 = {
  key: 0,
  class: "btn-group mr-1"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "btn-group mr-1"
}
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "dropdown-item text-muted"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "row",
  style: {"height":"100vh"}
}
const _hoisted_18 = { class: "col-xl-9 col-lg-8 col-md-7 col-sm-6" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = { class: "dashboard-box" }
const _hoisted_21 = { class: "mt-3" }
const _hoisted_22 = { class: "mt-3" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "font-italic"
}
const _hoisted_25 = { class: "mt-3" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  class: "font-italic"
}
const _hoisted_28 = {
  key: 0,
  class: "dashboard-box"
}
const _hoisted_29 = { class: "col-xl-3 col-lg-4 col-md-5 col-sm-6" }
const _hoisted_30 = { class: "dashboard-box" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 1,
  class: "text-muted font-italic"
}
const _hoisted_33 = { class: "dashboard-box" }
const _hoisted_34 = { class: "d-flex align-items-center mb-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = { class: "text-center mt-4" }
const _hoisted_38 = { class: "dashboard-box" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "text-muted" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "text-center mt-4" }
const _hoisted_44 = { class: "dashboard-box" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  style: {"margin-bottom":"10px"},
  class: "clearfix"
}
const _hoisted_47 = { target: "_blank" }
const _hoisted_48 = { class: "dropdown pull-right" }
const _hoisted_49 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "text-center mt-4" }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "dashboard-box" }
const _hoisted_54 = { class: "text-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativeEditorDialog = _resolveComponent("AlternativeEditorDialog")!
  const _component_EmailSender = _resolveComponent("EmailSender")!
  const _component_NoteLogger = _resolveComponent("NoteLogger")!
  const _component_LogsBrowser = _resolveComponent("LogsBrowser")!
  const _component_AlternativeRelationshipsDialog = _resolveComponent("AlternativeRelationshipsDialog")!
  const _component_MonthPickerDialog = _resolveComponent("MonthPickerDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_AttributeDataView = _resolveComponent("AttributeDataView")!
  const _component_FileUploader = _resolveComponent("FileUploader")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AlternativeEditorDialog, { viewModel: _ctx.alternativeEditorDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_EmailSender, {
      viewModel: _ctx.emailSender,
      onFormSubmit: _ctx.handleEmailSenderFormSubmit
    }, null, 8 /* PROPS */, ["viewModel", "onFormSubmit"]),
    _createVNode(_component_NoteLogger, {
      viewModel: _ctx.noteLogger,
      onCreateNote: _ctx.handleCreateNoteCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateNote"]),
    _createVNode(_component_LogsBrowser, { viewModel: _ctx.logsBrowser }, null, 8 /* PROPS */, ["viewModel"]),
    (_ctx.alternativeRelationshipsDialog)
      ? (_openBlock(), _createBlock(_component_AlternativeRelationshipsDialog, {
          key: 0,
          viewModel: _ctx.alternativeRelationshipsDialog,
          onLoadAlternatives: _ctx.loadAlternativesForDependencyDialog,
          onUnlinkDependent: _ctx.handleUnlinkDependentAlternativeCommand,
          onUnlinkFoundation: _ctx.handleUnlinkFoundationAlternativeCommand,
          onLinkFoundation: _ctx.handleLinkFoundationAlternativeCommand,
          onLinkDependent: _ctx.handleLinkDependentAlternativeCommand
        }, null, 8 /* PROPS */, ["viewModel", "onLoadAlternatives", "onUnlinkDependent", "onUnlinkFoundation", "onLinkFoundation", "onLinkDependent"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_MonthPickerDialog, {
      viewModel: _ctx.startDateMonthPicker,
      onUpdateDate: _ctx.handleUpdateAlternativeStartDateCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateDate"]),
    _createVNode(_component_MonthPickerDialog, {
      viewModel: _ctx.commitmentDateMonthPicker,
      onUpdateDate: _ctx.handleUpdateAlternativeCommitmentDateCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateDate"]),
    (_ctx.isWorkspaceMember)
      ? (_openBlock(), _createBlock(_component_PortfolioOrDecisionNavigation, {
          key: 1,
          workspaceId: _ctx.workspaceId,
          projectId: _ctx.projectId
        }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
      : (_ctx.isProjectOwner)
        ? (_openBlock(), _createBlock(_component_Navigation, { key: 2 }))
        : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.alternativeName), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[10] || (_cache[10] = [
            _createTextVNode("Business case", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/q/project/summary/${_ctx.workspaceId}/${_ctx.projectId}/${_ctx.alternativeId}`]
          ]),
          (_ctx.isWorkspaceMember)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  style: {"padding":"0.7em 2em"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAlternativeEditor(null))),
                  disabled: _ctx.rm == null
                }, "Edit", 8 /* PROPS */, _hoisted_8),
                _cache[12] || (_cache[12] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary dropdown-toggle dropdown-toggle-split",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false"
                }, [
                  _createElementVNode("span", { class: "sr-only" }, "Toggle Dropdown")
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_9, [
                  _cache[11] || (_cache[11] = _createElementVNode("h6", { class: "dropdown-header" }, "Custom forms", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (f) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "dropdown-item",
                      key: f.Id,
                      onClick: ($event: any) => (_ctx.showAlternativeEditor(f.Id))
                    }, _toDisplayString(f.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[14] || (_cache[14] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary dropdown-toggle",
                  style: {"padding":"0.7em 2em"},
                  "data-toggle": "dropdown",
                  "aria-expanded": "false"
                }, " Edit ", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_12, [
                  _cache[13] || (_cache[13] = _createElementVNode("h6", { class: "dropdown-header" }, "Custom forms", -1 /* CACHED */)),
                  (_ctx.forms.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.forms, (f) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: "dropdown-item",
                          key: f.Id,
                          onClick: ($event: any) => (_ctx.showAlternativeEditor(f.Id))
                        }, _toDisplayString(f.Name), 9 /* TEXT, PROPS */, _hoisted_13))
                      }), 128 /* KEYED_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "No custom forms available"))
                ])
              ])),
          (_ctx.isWorkspaceMember)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                class: "btn btn-outline-secondary",
                style: {"padding":"0.7em 2em"},
                href: `/#/sharing/resource/AlternativesDataShareResourceProvider/${_ctx.alternativeId}`
              }, [
                _cache[15] || (_cache[15] = _createTextVNode(" Share ", -1 /* CACHED */)),
                (_ctx.resourceActiveShares.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "(" + _toDisplayString(_ctx.resourceActiveShares.length) + ")", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_15))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _cache[42] || (_cache[42] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
      (_ctx.rm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchPhrase) = $event)),
                  placeholder: "Search...",
                  class: "form-control"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.searchPhrase]
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "input-group-append" }, [
                  _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("i", {
                      class: "fa-solid fa-magnifying-glass",
                      "aria-hidden": "true"
                    })
                  ])
                ], -1 /* CACHED */))
              ]),
              _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, [
                  _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Status", -1 /* CACHED */)),
                  _createElementVNode("div", null, _toDisplayString(_ctx.rm.StatusName), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Created", -1 /* CACHED */)),
                  _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("div", null, _toDisplayString(_ctx.rm.Created), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Start date", -1 /* CACHED */)),
                  _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showStartDateMonthPicker && _ctx.showStartDateMonthPicker(...args)))
                    }, [
                      (_ctx.startDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.startDateLabel), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_24, "Not defined"))
                    ])
                  ]),
                  _createCommentVNode("<div v-else :title=\"'Only workspace members can edit'\">\n                                <span v-if=\"startDate\">{{ startDateLabel }}</span>\n                                <span v-else class=\"font-italic\">Not defined</span>\n                            </div>")
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Commitment date", -1 /* CACHED */)),
                  _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showCommitmentDateMonthPicker && _ctx.showCommitmentDateMonthPicker(...args)))
                    }, [
                      (_ctx.commitmentDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.commitmentDateLabel), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_27, "Not defined"))
                    ])
                  ]),
                  _createCommentVNode("<div v-else :title=\"'Only workspace members can edit'\">\n                                <span v-if=\"commitmentDate\">{{ commitmentDateLabel }}</span>\n                                <span v-else class=\"font-italic\">Not defined</span>\n                            </div>")
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributesBySection[''], (attr) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: attr.AttributeId,
                    class: "mt-3"
                  }, [
                    _createVNode(_component_AttributeDataView, { readModel: attr }, null, 8 /* PROPS */, ["readModel"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rm.Sections, (s) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: s.Title
                }, [
                  (s.Title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("h4", null, _toDisplayString(s.Title), 1 /* TEXT */),
                        _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributesBySection[s.Title], (attr) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: attr.AttributeId,
                            class: "mt-3"
                          }, [
                            _createVNode(_component_AttributeDataView, { readModel: attr }, null, 8 /* PROPS */, ["readModel"])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[26] || (_cache[26] = _createElementVNode("h4", null, "Description", -1 /* CACHED */)),
                _cache[27] || (_cache[27] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                _createElementVNode("div", null, [
                  (_ctx.rm.Description)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: _ctx.marked(_ctx.rm.Description)
                      }, null, 8 /* PROPS */, _hoisted_31))
                    : (_openBlock(), _createElementBlock("span", _hoisted_32, "No description provided"))
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[30] || (_cache[30] = _createElementVNode("h4", null, "Contacts", -1 /* CACHED */)),
                _cache[31] || (_cache[31] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailContacts, (c) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.showEmailSender(c)),
                          class: "btn btn-outline-secondary btn-sm"
                        }, [...(_cache[28] || (_cache[28] = [
                          _createElementVNode("span", { class: "fa fa-envelope" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_35),
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(c.Name), 1 /* TEXT */),
                          _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _createElementVNode("small", _hoisted_36, _toDisplayString(c.Email), 1 /* TEXT */)
                        ])
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */)),
                  _createElementVNode("p", _hoisted_37, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showEmailSender(null)))
                    }, "Send email")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _cache[34] || (_cache[34] = _createElementVNode("h4", null, "Last activity", -1 /* CACHED */)),
                _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                (!_ctx.lastLogRm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.lastLogRm.Title), 1 /* TEXT */),
                        _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_41, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.getHumanizedTimeSince(_ctx.lastLogRm.Created)
                          }, null, 8 /* PROPS */, _hoisted_42),
                          _createTextVNode(" ago by " + _toDisplayString(_ctx.lastLogRm.Person), 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_43, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary mr-1",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showLogsBrowser && _ctx.showLogsBrowser(...args)))
                        }, "View logs"),
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleShowNoteLogger && _ctx.handleShowNoteLogger(...args)))
                        }, "Log a note")
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_44, [
                _cache[38] || (_cache[38] = _createElementVNode("h3", null, "Files", -1 /* CACHED */)),
                _cache[39] || (_cache[39] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                (_ctx.attachmentsRm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (!_ctx.file)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.attachmentsView, (at) => {
                            return (_openBlock(), _createElementBlock("div", null, [
                              _createElementVNode("div", _hoisted_46, [
                                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_47, [
                                  _createTextVNode(_toDisplayString(at.Title), 1 /* TEXT */)
                                ])), [
                                  [_directive_sanitizedHref, at.Url]
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _cache[36] || (_cache[36] = _createElementVNode("a", {
                                    "data-toggle": "dropdown",
                                    class: "pointer"
                                  }, [
                                    _createElementVNode("span", { class: "fa fa-bars" })
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.handleDeleteAttachedDocumentCommand(at))
                                    }, "Delete", 8 /* PROPS */, _hoisted_50)
                                  ])
                                ])
                              ])
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("p", _hoisted_51, [
                        _createVNode(_component_FileUploader, {
                          onSelected: _cache[7] || (_cache[7] = ($event: any) => (_ctx.file=$event)),
                          onUnselected: _cache[8] || (_cache[8] = ($event: any) => (_ctx.file=null)),
                          onUploaded: _ctx.handleAddAttachedDocumentCommand
                        }, null, 8 /* PROPS */, ["onUploaded"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_52, [...(_cache[37] || (_cache[37] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading... ", -1 /* CACHED */)
                    ]))]))
              ]),
              _createElementVNode("div", _hoisted_53, [
                _cache[40] || (_cache[40] = _createElementVNode("h3", null, "Dependencies", -1 /* CACHED */)),
                _cache[41] || (_cache[41] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, " This " + _toDisplayString(_ctx.rm.AlternativeLabel.toLowerCase()) + " is a foundation for " + _toDisplayString(_ctx.rm.Dependents.length) + " " + _toDisplayString(_ctx.rm.AlternativesLabel.toLowerCase()) + " and is dependent on " + _toDisplayString(_ctx.rm.Foundations.length) + " " + _toDisplayString(_ctx.rm.AlternativesLabel.toLowerCase()) + ". ", 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_54, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showDependenciesManager && _ctx.showDependenciesManager(...args)))
                    }, "Manage")
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}